import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { CourtDifficulty } from '../../interfaces/CourtInterfaces';

const LABELS = { none: 'Not difficult', watch: 'Watch', difficult: 'Difficult court' } as const;

/**
 * The court's difficulty score as a chip, with the reasons behind it on hover. Used on the court
 * page and next to hearings on the calendar, so both say the same thing in the same words.
 */
const CourtDifficultyChip: React.FC<{ difficulty: CourtDifficulty; showWhenNone?: boolean }> = ({
  difficulty,
  showWhenNone = false,
}) => {
  if (difficulty.level === 'none' && !showWhenNone) return null;
  const reasons = difficulty.reasons.length ? difficulty.reasons.join(', ') : 'Nothing that makes it harder';
  return (
    <Tooltip title={`Score ${difficulty.score}. ${reasons}`}>
      <Chip
        size="small"
        icon={difficulty.level === 'none' ? undefined : <WarningAmberIcon />}
        color={difficulty.level === 'difficult' ? 'error' : difficulty.level === 'watch' ? 'warning' : 'default'}
        variant={difficulty.level === 'none' ? 'outlined' : 'filled'}
        label={`${LABELS[difficulty.level]} · ${difficulty.score}`}
      />
    </Tooltip>
  );
};

export default CourtDifficultyChip;
